var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4266",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4270"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4280"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path4278"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g4272",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4276",
    clipPath: "url(#clipPath4280)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4282",
    transform: "translate(199.8862,231.9517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -168.338 c -13.282,0 -24.048,10.767 -24.048,24.048 V 248.5 c 0,13.282 10.766,24.048 24.048,24.048 H 56.114 c 13.282,0 24.048,-10.766 24.048,-24.048 V 80.162",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4284"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4286",
    transform: "translate(416.3228,280.0483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 64.129 C 77.411,0 88.177,-10.767 88.177,-24.048 V -248.5 c 0,-13.282 -10.766,-24.048 -24.048,-24.048 h -224.452 c -13.281,0 -24.048,10.766 -24.048,24.048 v 224.452 c 0,13.281 10.767,24.048 24.048,24.048 h 128.26",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4288"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4290",
    transform: "translate(71.6289,424.3389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 144.291",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4292"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4294",
    transform: "translate(106.7788,392.3105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 12.426,-27.68 37.418,-67.625 85.092,-96.23",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4296"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4298",
    transform: "translate(191.8711,424.3389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,0 -16.032,-80.162 -96.194,-128.258",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4300"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4302",
    transform: "translate(143.7744,424.3389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 16.032",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4304"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4306",
    transform: "translate(311.2656,71.6289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 54.181,142.258 c 1.107,2.707 4.939,2.711 6.051,0.006 L 113.92,0",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4308"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4310",
    transform: "translate(328.1631,107.0586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 80.398",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4312"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4314",
    transform: "translate(183.8564,95.6772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -32.066 c -30.991,0 -56.113,25.123 -56.113,56.113 v 48.094",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4316"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4318",
    transform: "translate(167.8228,119.7256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 32.064,-24.048 0,-48.097",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4320"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4322",
    transform: "translate(328.1436,416.3228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 32.066 c 30.991,0 56.113,-25.123 56.113,-56.113 v -48.094",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4324"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4326",
    transform: "translate(344.1772,392.2744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -32.064,24.048 0,48.097",
    style: {
      fill: "none",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path4328"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.993fe27f108f696aaae76d57c04eb398.svg";
export { ForwardRef as ReactComponent };